import { library } from '@fortawesome/fontawesome-svg-core';
import { faChevronLeft, faCog, faUserCircle } from '@fortawesome/free-solid-svg-icons';

library.add(faChevronLeft, faCog, faUserCircle);
